import React, { useContext } from "react";

export const FilterContext = React.createContext({});

export function useFilter() {
  const data = useContext(FilterContext);
  return data;
}
